import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Text } from '@qga/roo-ui/components';
import { getQueryCheckIn, getQueryCheckOut, getQueryAdults, getQueryChildren, getQueryInfants } from 'store/router/routerSelectors';
import NumberOfNights from 'components/NumberOfNights';
import styled from '@emotion/styled';

const NightsAndGuestsWrapper = styled(Box)`
  display: inline;
  font-weight: 400;
  font-size: 16px;
`;

const NightsAndGuests = () => {
  const checkIn = useSelector(getQueryCheckIn);
  const checkOut = useSelector(getQueryCheckOut);
  const adults = useSelector(getQueryAdults);
  const children = useSelector(getQueryChildren);
  const infants = useSelector(getQueryInfants);
  const totalGuests = adults + children + infants;

  return (
    <NightsAndGuestsWrapper data-testid="nights-guests-new">
      <Text data-testid="guests" color={'greys.steel'}>
        {' '}
        {totalGuests} guests •{' '}
      </Text>
      <NumberOfNights checkIn={checkIn} checkOut={checkOut} color={'greys.steel'} font={'16px'} />
      <Text color={'greys.steel'}> from</Text>
    </NightsAndGuestsWrapper>
  );
};

export default NightsAndGuests;
